import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["heading"]

  connect() {
    if (window.location.hash !== `#${this.element.id}`) return

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

        this.element.scrollIntoView({
          behavior: reducedMotion ? "auto" : "smooth",
          block: "start",
        })
        this.headingTarget.focus({ preventScroll: true })
      })
    })
  }
}
